import * as yup from 'yup';

const formValidation = yup.object().shape({
    firstName: yup
        .string('Enter your first name')
        .matches(
            /^[A-Za-z]*$/,
            'Please enter a valid name (make sure there is no punctuation or extra spaces)'
        )
        .required('First name is required'),
    lastName: yup
        .string('Enter your last name')
        .matches(
            /^[A-Za-z]*$/,
            'Please enter a valid name (make sure there is no punctuation or extra spaces)'
        )
        .required('Last name is required'),
    email: yup
        .string('Enter your email')
        .email('Enter a valid email')
        .required('Email is required'),
    institution: yup.string('Enter your institution').required('Institution is required'),
    profession: yup.string('Select your profession').required('Profession is required'),
    professionOther: yup
        .string('Describe your profession')
        .ensure()
        .when('profession', {
            is: 'Other',
            then: yup.string().required('Please specify a profession')
        }),
    accreditingBody: yup
        .string('Select the accrediting body')
        .ensure()
        .when('profession', {
            is: 'Physician',
            then: yup.string().required('Please select the accrediting body')
        }),
    accreditingBodyOther: yup
        .string('Specify the accrediting body')
        .ensure()
        .when('accreditingBody', {
            is: 'Other',
            then: yup.string().required('Please specify the accrediting body ')
        })
});

export default formValidation;
